import React from "react";
import { Row, Col, Modal, Alert, Form, Nav, Spinner } from "react-bootstrap";
import RenderAuthNav from "./_renderAuthNav";

class ModalAdminUser extends React.Component {
  state = {
    loading: {
      text:
        "Uživatel byl načten, po jakékoli změně je nutné, aby se daný uživatel odhlásil a znovu přihlásil",
      status: false,
      variant: "info",
    },
    selectGroup: 0,
  };
  render() {
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={() => this.props.hide()}
          centered
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <span className="h5">
                {this.props.users.filter((f) => f.id === this.props.idx)[0]
                  ?.userName
                  ? this.props.users.filter((f) => f.id === this.props.idx)[0]
                      ?.userName
                  : this.props.users.filter((f) => f.id === this.props.idx)[0]
                      ?.email}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Alert variant={this.state.loading.variant}>
            <Row>
              <Col className="d-flex justify-content-between">
                {this.state.loading.text}
                {this.state.loading.status && (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                )}
              </Col>
            </Row>
          </Alert>
          <Modal.Body>
            <Row className="mb-2">
              <Col xs={12}>
                <Form.Select value={this.props.users.filter(f => f.id === this.props.idx)[0]?.type}>
                  <option value="user">User</option>
                  <option value="partner">Partner</option>
                  <option value="domain">Domain</option>
                </Form.Select>
                <Form.Text>Typ uživatele</Form.Text>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={12}>
                <Nav
                  variant="tabs"
                  className="c-tab"
                  defaultActiveKey={this.state.selectGroup}
                >
                  <Nav.Item>
                    <Nav.Link
                      onClick={() => this.setState({ selectGroup: 0 })}
                      eventKey="0"
                    >
                      Základní
                    </Nav.Link>
                  </Nav.Item>
                  {this.props.users.filter((f) => f.id === this.props.idx)[0]
                    ?.type != "domain" && (
                    <Nav.Item>
                      <Nav.Link
                        onClick={() => this.setState({ selectGroup: 1 })}
                        eventKey="1"
                      >
                        Adresy
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  {this.props.users[this.props.idx]?.type == "domain" && (
                    <>
                      <Nav.Item>
                        <Nav.Link
                          onClick={() => this.setState({ selectGroup: 3 })}
                          eventKey="3"
                        >
                          Interní
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          onClick={() => this.setState({ selectGroup: 4 })}
                          eventKey="4"
                        >
                          Personalistika
                        </Nav.Link>
                      </Nav.Item>
                    </>
                  )}
                  <Nav.Item>
                    <Nav.Link
                      onClick={() => this.setState({ selectGroup: 2 })}
                      eventKey="2"
                    >
                      Oprávnění
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col>
                {this.state.selectGroup == 2 && (
                  <RenderAuthNav {...this.props} />
                )}
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default ModalAdminUser;
